module.exports = __webpack_public_path__ + "img/applying.dec67880.jpg";